module.exports = __webpack_public_path__ + "static/img/home-banners-mob31.2cd14f5e.jpg";